import {
  initialState,
  Actions,
  State,
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_ERROR,
  SIGN_UP,
  SIGN_UP_SUCCESS,
  SIGN_UP_ERROR,
  SIGN_OUT,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_ERROR,
  RECOVER_PASSWORD,
  RECOVER_PASSWORD_SUCCESS,
  RECOVER_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "../types/auth";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SIGN_IN:
      return {
        ...state,
        signin: {
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        signin: {
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case SIGN_IN_ERROR:
      return {
        ...state,
        signin: {
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case SIGN_UP:
      return {
        ...state,
        signup: {
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        signup: {
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case SIGN_UP_ERROR:
      return {
        ...state,
        signup: {
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case SIGN_OUT:
      return {
        ...state,
        signout: {
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        signout: {
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case SIGN_OUT_ERROR:
      return {
        ...state,
        signout: {
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RESET_PASSWORD:
      return {
        ...state,
        resetPassword: {
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: {
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPassword: {
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RECOVER_PASSWORD:
      return {
        ...state,
        recoverPassword: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case RECOVER_PASSWORD_SUCCESS:
      return {
        ...state,
        recoverPassword: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case RECOVER_PASSWORD_ERROR:
      return {
        ...state,
        recoverPassword: {
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    default:
      return state;
  }
};

export default reducers;
